import DatatablesController from '../../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns() {
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'word',
        title: 'Kata',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<code class="font-weight-bolder">${data.word}</code>`;
        }
      },
      {
        field: 'is_active',
        title: 'Status',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        width: 90,
        template: function(data) {
          if (data.is_active) {
            return `<span class="badge badge-success">Aktif</span>`;
          }
          return `<span class="badge badge-secondary">Nonaktif</span>`;
        }
      },
      {
        field: 'flagged_count',
        title: 'Thread Ditandai',
        overflow: 'visible',
        autoHide: false,
        width: 110,
        template: function(data) {
          if (data.flagged_count > 0) {
            return `<span class="badge badge-warning">${data.flagged_count}</span>`;
          }
          return `<span class="text-muted">0</span>`;
        }
      },
      {
        field: 'created_by',
        title: 'Ditambah Oleh',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="text-muted">${data.created_by || '-'}</span>`;
        }
      },
      {
        field: 'created_at',
        title: 'Tanggal',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="text-muted font-size-sm">${data.created_at}</span>`;
        }
      },
      {
        field: 'Actions',
        title: 'Aksi',
        sortable: false,
        width: 100,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.toggle_path}"
               data-method="patch" title="${data.is_active ? 'Nonaktifkan' : 'Aktifkan'}">
              <i class="fa fa-toggle-${data.is_active ? 'on text-success' : 'off text-secondary'}"></i>
            </a>
            <a class="btn btn-sm btn-clean btn-icon" href="${data.delete_path}"
               data-method="delete" data-confirm="Hapus kata ini dari daftar?" title="Hapus">
              <i class="fa fa-trash text-danger"></i>
            </a>
          `;
        }
      }
    ];
  }
}
